<template>
  <div class="app-container">
    <div>
      <el-select v-model="curRole" clearable filterable @change="onRoleChange">
        <el-option v-for="item in roleList" :value="item.roleID" :key="item.roleID" :label="item.roleName"></el-option>
      </el-select>
      <el-button style="margin-left: 20px" type="primary" size="small" @click="menuRoleBind">分配菜单</el-button>
    </div>
    <div style="padding-top: 20px;">
      <el-tree ref="treeRef" :filter-node-method="filterNode" default-expand-all :data="menuList" show-checkbox
               :props="defaultProps" node-key="menuId"></el-tree>
    </div>
  </div>

</template>

<script>
import {getRoleList} from "@/api/role";
import {getAvailableList, getUserAvailableMenuList, getUserRoleAvailableMenuList, menuRoleBind} from "@/api/menu/menu";
import {handleRes} from "@/utils/handleRes";
import {isVaild} from "@/utils/validate";
import {printObj} from "@/utils/debug";

export default {
  name: "roleMenuBinding",
  created() {
    this.getRoleList()
    this.getAvailableList()
  },
  data() {
    return {
      defaultProps: {
        children: 'childMenuList',
        label: 'menuName',
      },
      roleList: [],
      curRole: "",
      menuList: [],
      roleMenuList: []
    }
  },
  methods: {
    getRoleList() {
      getRoleList().then(res => {
        return res.data.totalCount
      }).then(res => {
        return getRoleList({
          pageSize: res
        })
      }).then(res => {
        this.roleList = res.data.result
      })
    },
    onRoleChange() {
      this.getRoleMenu()
    },
    getAvailableList() {
      getAvailableList().then(res => {
        handleRes(res, () => {
          this.menuList = res.data
        })
      })
    },
    getRoleMenu() {
      getUserRoleAvailableMenuList({
        roleId: this.curRole
      }).then(res => {
        handleRes(res, () => {
          this.roleMenuList = res.data

          let checkKeys = this.handleMenuSelect(this.roleMenuList)
          this.$refs.treeRef.setCheckedKeys(checkKeys)
        })
      })
    },
    handleMenuSelect(menu) {
      //
      if (!(isVaild(menu) && menu.length > 0)) {
        return []
      }
      let checkKeys = []
      //有子菜单才勾，父菜单不勾，没子菜单直接勾父菜单
      for (let menuIndex = 0; menuIndex < menu.length; menuIndex++) {
        let cur = menu[menuIndex]
        //有子菜单，勾选子菜单，父菜单不用勾
        if (isVaild(cur.childMenuList) && cur.childMenuList.length > 0) {
          let temp = this.handleMenuSelect(cur.childMenuList)
          temp.forEach((item) => {
            checkKeys.push(item)
          })
        } else {
          //没有子菜单，直接勾父菜单
          checkKeys.push(cur.menuId)
        }
      }
      return checkKeys
    },
    filterNode(value, data) {
      // if (!value) return true
      return data.roleName.includes(value)
    },
    menuRoleBind() {
      let para = {
        menuIdList: this.$refs.treeRef.getCheckedKeys(),
        roleId: this.curRole
      }
      // printObj(para)
      menuRoleBind(para).then(res => {
        handleRes(res, () => {
          this.getRoleMenu()
          this.$message.success('操作成功')
        })
      })
    }
  },
}
</script>

<style scoped>
div.center {
  justify-content: center;
  align-content: center;
  display: flex;
}
</style>